import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Lightbulb, ShieldCheck, Download, Zap } from 'lucide-react';
export function Solution() {
  const solutions = ['CÓMO EMPEZAR EN AMAZON DESDE CERO', 'QUÉ PRODUCTOS ELEGIR', 'CÓMO ANALIZAR CORRECTAMENTE', 'CÓMO LANZAR TU PRODUCTO PASO A PASO', 'CÓMO EVITAR ERRORES QUE CUESTAN DINERO'];
  const results = ['ENTENDER CÓMO FUNCIONA AMAZON DESDE CERO', 'SABER EXACTAMENTE QUÉ PRODUCTO ELEGIR', 'EVITAR ERRORES QUE HACEN PERDER DINERO', 'TENER CLARIDAD EN CADA PASO', 'AVANZAR CON SEGURIDAD'];
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white py-24 px-6" data-id="element-700">
      <div className="max-w-6xl mx-auto" data-id="element-701">
        {/* Title */}
        <FadeIn data-id="element-702">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-brand-green mb-6 tracking-wide" data-id="element-703">
            ESTO NO ES SOLO INFORMACIÓN… ES UNA GUÍA PRÁCTICA PARA EMPEZAR
          </h2>
        </FadeIn>

        {/* Supporting text */}
        <FadeIn delay={0.1} data-id="element-704">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-705">
            <p className="text-lg md:text-xl text-brand-text/70 mb-3 font-medium" data-id="element-706">
              Es un sistema paso a paso que te enseña a usar Amazon Seller como
              una herramienta real para generar ingresos desde casa.
            </p>
            <p className="text-lg md:text-xl text-brand-text/70 mb-3" data-id="element-707">
              Vas a aprender cómo funciona la plataforma, cómo ingresar
              productos correctamente, cómo analizar oportunidades reales y cómo
              lanzar con una estructura clara.
            </p>
            <p className="text-lg md:text-xl text-brand-text/70 mb-3" data-id="element-708">
              No es teoría. Es un método práctico pensado para que puedas
              aplicar desde el inicio.
            </p>
            <p className="text-lg md:text-xl text-brand-green font-semibold" data-id="element-709">
              👉 Todo explicado de forma clara para que puedas avanzar sin
              confusión.
            </p>
          </div>
        </FadeIn>

        {/* Two-column layout: content left, image right */}
        <div className="flex flex-col lg:flex-row items-start gap-16 mb-16" data-id="element-710">
          {/* Left column — lists */}
          <div className="flex-1 w-full" data-id="element-711">
            {/* Solutions list */}
            <div className="space-y-4 mb-12" data-id="element-712">
              {solutions.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-713">
                  <div className="flex items-center gap-4 bg-brand-beige/40 p-5 rounded-xl border border-brand-green/5" data-id="element-714">
                    <CheckCircle2 className="w-7 h-7 text-brand-green flex-shrink-0" data-id="element-715" />
                    <p className="text-lg md:text-xl font-semibold text-brand-text" data-id="element-716">
                      {item}
                    </p>
                  </div>
                </FadeIn>)}
            </div>

            {/* Results block */}
            <FadeIn delay={0.6} data-id="element-717">
              <div className="mb-12" data-id="element-718">
                <div className="flex items-center gap-3 mb-6" data-id="element-719">
                  <Lightbulb className="w-7 h-7 text-brand-gold" data-id="element-720" />
                  <h3 className="text-2xl md:text-3xl font-bold text-brand-green" data-id="element-721">
                    LO QUE REALMENTE VAS A LOGRAR:
                  </h3>
                </div>
                <div className="space-y-3" data-id="element-722">
                  {results.map((item, index) => <div key={index} className="flex items-center gap-4 pl-2" data-id="element-723">
                      <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0" data-id="element-724" />
                      <p className="text-lg font-medium text-brand-text" data-id="element-725">
                        {item}
                      </p>
                    </div>)}
                </div>
              </div>
            </FadeIn>

            {/* Sin información confusa block */}
            <FadeIn delay={0.7} data-id="element-726">
              <div className="bg-brand-beige rounded-2xl p-8 shadow-sm border border-brand-gold/15" data-id="element-727">
                <p className="text-xl font-semibold text-brand-green mb-4 flex items-center justify-center gap-2" data-id="element-728">
                  <span data-id="element-729">👉</span> SIN INFORMACIÓN CONFUSA
                </p>
                <p className="text-xl font-semibold text-brand-green flex items-center justify-center gap-2" data-id="element-730">
                  <span data-id="element-731">👉</span> SIN PASOS COMPLICADOS
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Right column — Image */}
          <div className="flex-shrink-0 w-full lg:w-[38%] lg:sticky lg:top-24" data-id="element-732">
            <FadeIn delay={0.4} data-id="element-733">
              <img src="https://cdn.magicpatterns.com/uploads/k8a1ewWKihihNeRboYEFkL/ChatGPT_Image_7_abr_2026,_06_45_05.png" alt="Mujer trabajando desde casa con laptop, ambiente cálido y productivo" className="w-full h-auto rounded-2xl shadow-lg object-contain" data-id="element-734" />
            </FadeIn>
          </div>
        </div>

        {/* CTA Button */}
        <FadeIn delay={0.8} data-id="element-735">
          <div className="text-center" data-id="element-736">
            <Button onClick={goToCheckout} className="text-lg px-10 py-5" data-id="element-737">
              QUIERO EMPEZAR AHORA
            </Button>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-738">
              <span className="flex items-center gap-1.5" data-id="element-739">
                <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-740" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-1.5" data-id="element-741">
                <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-742" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-1.5" data-id="element-743">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-744" />
                COMPRA SEGURA
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}